//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      Password: "",
      oldPassword: "",
      replayPass: ""
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    }
  },
  created: function created() {},
  methods: {
    editPassword: function editPassword() {
      var that = this;

      if (this.oldPassword == "") {
        that.$message.warning("旧密码不可为空");
        return false;
      }

      if (this.Password == "") {
        that.$message.warning("新密码不可为空");
        return false;
      }

      if (this.replayPass == "") {
        that.$message.warning("请确认密码");
        return false;
      }

      if (this.Password != this.replayPass) {
        that.$message.warning("确认密码错误，请重新输入");
        that.replayPass = "";
        return false;
      }

      this.$http.post("/api/XOrg/AOrgInfo/editPassword", {
        Password: this.Password,
        oldPassword: this.oldPassword
      }).then(function (rst) {
        if (rst.code > 0) {
          that.cancel();
          that.$message.success(rst.msg);
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    cancel: function cancel() {
      this.Password = "";
      this.oldPassword = "";
      this.replayPass = "";
    }
  }
};